import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface KanbanMarcadorTransferenciaDialogData {
  tipoNome: string;
  nomeAnterior: string;
  nomeNovo: string;
}

@Component({
  selector: 'app-kanban-marcador-transferencia-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './kanban-marcador-transferencia-dialog.component.html',
  styleUrls: ['./kanban-marcador-transferencia-dialog.component.css'],
})
export class KanbanMarcadorTransferenciaDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<KanbanMarcadorTransferenciaDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: KanbanMarcadorTransferenciaDialogData
  ) {}

  public confirmar(): void {
    this.dialogRef.close(true);
  }

  public cancelar(): void {
    this.dialogRef.close(false);
  }
}
